import React from 'react';
import ReCAPTCHA from 'react-google-recaptcha';

import utils from '@utils';
import {Props} from './types';
import './index.scss';

const env = utils.env.get();

const ReCaptcha = React.forwardRef<any, Props>((props, ref) => (
  <div className="a__recaptcha">
    {env.RECAPTCHA_SITE_KEY ? (
      <ReCAPTCHA
        ref={ref}
        sitekey={env.RECAPTCHA_SITE_KEY}
        onChange={(value: any) => props.onChange(value)}
        onExpired={() => props.onChange(null)}
      />
    ) : null}
  </div>
));

export default ReCaptcha;
